export const benefitsOptions = {
  hasLifeInsurance: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  lifeInsuranceMovementType: [
    { value: "1", label: "Manual" },
    { value: "2", label: "Automático" },
  ],
  lifeInsuranceMovementReport: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  lifeInsuranceDiscountValue: [
    { value: "1", label: "Fixo" },
    { value: "2", label: "% Salário" },
    { value: "3", label: "Outro" },
  ],
  lifeInsuranceProLabore: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  lifeInsuranceIntern: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  lifeInsuranceApprentice: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  lifeInsuranceOnLeave: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  lifeInsuranceDiscountOnPayroll: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  lifeInsuranceDiscountInTermination: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  lifeInsuranceUnusedBenefitDiscount: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  lifeInsuranceOtherRules: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasHealthPlan: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasMoreThanOneHealthPlan: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOperator1Type: [
    { value: "1", label: "Faixa salarial" },
    { value: "2", label: "Faixa etária" },
    { value: "3", label: "Valor Fixo" },
    { value: "4", label: "% s/ salário" },
    { value: "5", label: "Salarial | Etária" },
  ],
  healthPlanOperator1HasCoparticipation: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOperator1CoparticipationRule: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOperator1BeneficiariesOutsideEmployees: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOperator2Type: [
    { value: "1", label: "Faixa salarial" },
    { value: "2", label: "Faixa etária" },
    { value: "3", label: "Valor Fixo" },
    { value: "4", label: "% s/ salário" },
    { value: "5", label: "Salarial | Etária" },
  ],
  healthPlanOperator2HasCoparticipation: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOperator2CoparticipationRule: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOperator2BeneficiariesOutsideEmployees: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanDiscountOnPayroll: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  healthPlanDiscountInTermination: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanUnusedBenefitDiscount: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  healthPlanOtherRules: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasDentalPlan: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasMoreThanOneDentalPlan: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  dentalPlanOperator1Type: [
    { value: "1", label: "Faixa salarial" },
    { value: "2", label: "Faixa etária" },
    { value: "3", label: "Valor Fixo" },
    { value: "4", label: "% s/ salário" },
    { value: "5", label: "Salarial | Etária" },
  ],
  dentalPlanOperator1BeneficiariesOutsideEmployees: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  dentalPlanOperator2Type: [
    { value: "1", label: "Faixa salarial" },
    { value: "2", label: "Faixa etária" },
    { value: "3", label: "Valor Fixo" },
    { value: "4", label: "% s/ salário" },
    { value: "5", label: "Salarial | Etária" },
  ],
  dentalPlanOperator2BeneficiariesOutsideEmployees: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  dentalPlanDiscountOnPayroll: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  dentalPlanDiscountInTermination: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  dentalPlanUnusedBenefitDiscount: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  dentalPlanOtherRules: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasTransportationVoucher: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  transportationCalcExecution: [
    { value: "1", label: "Manual" },
    { value: "2", label: "Automático" },
  ],
  transportationDeductAbsences: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  transportationDeductMedicalCertificates: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  transportationBenefitForAccidentLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  transportationBenefitForIllnessLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  transportationBenefitForMaternityLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  transportationBenefitDuringVacation: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  transportationOtherDeductionFactors: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  transportationPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  transportationTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  transportationUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasMobilityVoucher: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mobilityCalcExecution: [
    { value: "1", label: "Manual" },
    { value: "2", label: "Automático" },
  ],
  mobilityDeductAbsences: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  mobilityDeductMedicalCertificates: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  mobilityBenefitForAccidentLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mobilityBenefitForIllnessLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mobilityBenefitForMaternityLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mobilityBenefitDuringVacation: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  mobilityOtherDeductionFactors: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mobilityPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  mobilityTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mobilityUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasFoodVoucher: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  foodCalcExecution: [
    { value: "1", label: "Manual" },
    { value: "2", label: "Automático" },
  ],
  foodDeductAbsences: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  foodDeductMedicalCertificates: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  foodBenefitForAccidentLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  foodBenefitForIllnessLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  foodBenefitForMaternityLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  foodBenefitDuringVacation: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  foodOtherDeductionFactors: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  foodPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  foodTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  foodUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasMealVoucher: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mealCalcExecution: [
    { value: "1", label: "Manual" },
    { value: "2", label: "Automático" },
  ],
  mealDeductAbsences: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  mealDeductMedicalCertificates: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  mealBenefitForAccidentLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mealBenefitForIllnessLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mealBenefitForMaternityLeave: [
    { value: "3", label: "Proporcional" },
    { value: "4", label: "Integral" },
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mealBenefitDuringVacation: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  mealOtherDeductionFactors: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mealPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  mealTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  mealUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasBasicBasket: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  basicBasketPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  basicBasketTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  basicBasketUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasCanteen: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  canteenPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  canteenTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  canteenUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasOtherBenefits: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasPharmacy: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  pharmacyInfoFormat: [
    { value: "1", label: "PDF" },
    { value: "2", label: "TXT" },
    { value: "3", label: "CSV" },
    { value: "4", label: "EXCEL" },
  ],
  pharmacyPayrollDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  pharmacyTerminationDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  pharmacyUnusedBenefitDeduction: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasOtherAgreements: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasSocialSecurity: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasPowerOfAttorney: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasLegalRepresentativeRegistered: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
};
